import { render, staticRenderFns } from "./AutoCapture.vue?vue&type=template&id=1f463503&lang=pug"
import script from "./AutoCapture.vue?vue&type=script&lang=js"
export * from "./AutoCapture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports